export const enum P1_VALUES {
  SHOW_ADDRESS_IN_DEVICE = 0x00,
  ONLY_RETRIEVE = 0x01,
}

export const PUBKEYLEN = 55;
